/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RouteErrorBoundary from '../../components/error/RouteErrorBoundary';
import { AppRouteInterface, RouteInterface, RoutesInterface } from '../../types/routes';
import { AppLayout } from '../../layout/AppLayout';
import Header from '../../components/header';
import UTrModal from '../../components/utr-modal';
import { AppHeader } from '../../components/header/AppHeader';
import AssuranceTrackerLogo from '../../images/Assurance_Tracker.svg';
import AssuranceList from '../../components/assurer/assurance-list';
import AssurerAssurancePortfolio, {
  assurancePortfolioRoute,
} from '../../components/assurer/assurer-assurance-portfolio';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../selectors/user';
import NotAuthorised from '../not-authorised';

export const assuranceRouteEntry: RouteInterface = {
  id: 'assurance_root',
  label: 'Assurance Tracker',
  tooltip: 'Assurance Tracker',
  path: '/assurance',
  icon: 'fa-folder-open',
  component: Assurance,
  appPermissionId: 'app_assurance',
  exact: false,
  auth: true,
};

const otherRoutes: RoutesInterface = {
  ASSURANCE_PORTFOLIO: {
    ...assurancePortfolioRoute,
    component: AssurerAssurancePortfolio,
  }
}

export const assuranceRoutes: RoutesInterface = {
  ASSURANCE: assuranceRouteEntry,
  ...otherRoutes
}

const assuranceAppRoute: AppRouteInterface = {
  appName: 'Assurance Tracker',
  appIcon: AssuranceTrackerLogo,
  routes: [
    assuranceRoutes.ASSURANCE_PORTFOLIO
  ],
}

export function Assurance() {

  const currentUser = useSelector(getCurrentUser);

  const hasOrganization = Boolean(currentUser?.organizationId);

  return (
    <RouteErrorBoundary>
      <AppLayout Header={
        <Header>
          <AppHeader
            appRoute={assuranceAppRoute}
            route={assuranceRouteEntry} />
        </Header>
      }>
        {hasOrganization ?
          (
            <Switch>
              {Object.entries(otherRoutes).map(([k, route]) => {
                return <Route
                  key={`route_${route.id}`}
                  {...route}
                  exact={route.exact ?? false} />
              })}
              <Route>
                <AssuranceList />
              </Route>
            </Switch>
          ) : <NotAuthorised />
        }
        <UTrModal />
      </AppLayout>
    </RouteErrorBoundary>
  )
}

export default Assurance;
